module.exports = "<div *ngIf=\"!auth.currentUser\">\r\n  <button (click)=\"signInWithGoogle()\">\r\n    Connect Google\r\n  </button>\r\n  \r\n</div>"